import {Store,Module,ActionContext} from 'vuex'
import {ListModule, ListState,ListMutations, ListStateItem, ListModuleItem} from '@/store/shared'
import {$http} from '@/lib'
import {PageResult} from '@/store/shared/entity';

import Logistics from './entity'
import Tree from "@/store/shared/entity/tree";

interface LogisticsState extends ListStateItem<Logistics>{
    editLogistics:Logistics,
    logisticsList: Array<any>;
    logisticsLists: Array<any>;
    logisticsIdList: Array<any>;
}

class LogisticsModule extends ListModuleItem<LogisticsState,any,Logistics>{

    constructor() {
        super();
        Object.assign(this.state, this.overrideState);
        Object.assign(this.mutations, this.overrideMutations);
    }

    overrideState={
        editLogistics:new Logistics(),
        logisticsList: new Array<any>(),
        logisticsLists: new Array<any>(),
        logisticsIdList:new Array<any>(),
    }
    actions={
        async getAll(context:ActionContext<LogisticsState,any>,payload:any){
            context.state.table.loading=true;
            let reponse=await $http.get('services/app/Logistics/GetAll',{params:payload.data});
            context.state.table.loading=false;
            let page=reponse.data.result as PageResult<Logistics>;
            context.state.table.totalCount=page.totalCount;
            context.state.table.list=page.items;
        },
        async create(context:ActionContext<LogisticsState,any>,payload:any){
            await $http.post('services/app/Logistics/Create',payload.data);
        },
        async update(context:ActionContext<LogisticsState,any>,payload:any){
            await $http.put('services/app/Logistics/Update',payload.data);
        },
        async delete(context:ActionContext<LogisticsState,any>,payload:any){
            await $http.delete('services/app/Logistics/Delete?Id='+payload.data.id);
        },
        async get(context:ActionContext<LogisticsState,any>,payload:any){
            let reponse=await $http.get('services/app/Logistics/Get?Id='+payload.id);
            return reponse.data.result as Logistics;
        },
        async getLogisticsList(context:ActionContext<LogisticsState,any>){
            
            let reponse = await $http.get('services/app/Logistics/GetLogisticsOption');
            context.state.logisticsLists = reponse.data.result;
            
        },
        async getLogisticsIdOption(context:ActionContext<LogisticsState,any>){
            
            let reponse = await $http.get('services/app/Logistics/GetLogisticsIdOption');
            context.state.logisticsIdList = reponse.data.result;
            
        },
        async getIsTraileLogisticsList(context:ActionContext<LogisticsState,any>){
            let reponse = await $http.get('services/app/Logistics/GetIsTrailerLogisticsOption');
            context.state.logisticsList = reponse.data.result;
            
        },
    };
    overrideMutations={
        edit(state:LogisticsState,factory:Logistics){
            state.editLogistics=factory;
        }
    }
}
const logisticsModule=new LogisticsModule();
export default logisticsModule;